import { createMedia } from '@artsy/fresnel';

// https://github.com/artsy/fresnel/issues/170

/*
  Api: at, between, lessThan, greaterThan, greaterThanOrEqual
  Usage: <Breakpoint at="small"> <AnyComponent /> </Breakpoint>
*/

const appMedia = createMedia({
  breakpoints: {
    xsmall: 0,
    small: 576, // mobile devices
    medium: 768, // ipad, ipad pro, ipad mini, etc
    large: 992, // smaller laptops
    xlarge: 1200, // laptops and desktops
    xxlarge: 9999,
    //Custom filter bar breaks
    sortSelectorBreak: 540,
    projectTypeFilterBreak: 640,
    priceFilterBreak: 1020,
    sizeFilterBreak: 1160,
    // Breakpoint for Reassurance Banner
    largeScreens: 1400,
  },
  interactions: {
    hover: '(hover: hover)',
    notHover: '(hover: none)',
    landscape: 'not all and (orientation: landscape)',
    portrait: 'not all and (orientation: portrait)',
  },
});

// Generates CSS to be injected into the head
export const mediaStyle = appMedia.createMediaStyle();
export const { Media: Breakpoint, MediaContextProvider } = appMedia;
